import { createTheme } from "@material-ui/core/styles";

// Variables
let variables = {
  border: {
    primary: "rgb(213, 205, 205)",
  },
  text: {
    primary: "#000000",
    secondary: "#0028fa",
  },
};

// default theme
const theme = createTheme();

export const customTheme = createTheme({
  mainContent: {
    width: "100%",
    maxWidth: theme.breakpoints.values.lg,
    padding: "15px 0px",
  },
  mainContentMD: {
    width: "100%",
    maxWidth: "960px",
    padding: "15px",
    margin: "0 auto",
  },
  overrides: {
    MuiFormHelperText: {
      root: {
        fontFamily: ['"Source Sans Pro"', "sans-serif"].join(", "),
        textAlign: "left",
      },
    },
    MuiButton: {
      contained: {
        boxShadow: "none",
        "&:hover, &:active, &:focus": {
          boxShadow: "none",
        },
      },
    },
    MuiDivider: {
      vertical: {
        alignSelf: "stretch",
        height: "auto",
        margin: "0 0.5rem",
      },
    },
    MuiTableHead: {
      root: { background: "#F2F5F7", textTransform: "uppercase" },
    },
    MuiTableContainer: {
      root: { overflowX: "unset" },
    },
    MuiListItem: {
      root: {
        "&$selected": {
          backgroundColor: "#f7f7f8",
          fontWeight: 700,
          borderRadius: "15px 0px 0px 15px",
        },
      },
    },
  },
  palette: {
    primary: {
      light: "#333f4c",
      main: "#000000",
      dark: "#6d7b8a",
      contrastText: "#fff",
    },
    secondary: {
      light: "#972f21",
      main: "#D94430",
      dark: "#e06959",
      contrastText: "#fff",
    },
    yellow: {
      light: "#d7e360",
      main: "#cddc39",
      dark: "#8f9a27",
      contrastText: "#000",
    },
    green: {
      light: "#357a38s",
      main: "#000000",
      dark: "#6fbf73",
      contrastText: "#fff",
    },
    text: {
      primary: "#000000",
    },
  },
  typography: {
    h1: {
      fontFamily: ['"Mulish"', "sans-serif"].join(", "),
      fontSize: "18px",
      lineHeight: "26px",
      margin: 0,
      padding: 0,
    },
    h2: {
      fontFamily: ['"Mulish"', "sans-serif"].join(", "),
      fontSize: "14px",
      lineHeight: "19px",
      margin: 0,
      padding: 0,
    },
    h3: {
      fontFamily: ['"Mulish"', "sans-serif"].join(", "),
      fontSize: "1.5rem",
      fontWeight: 400,
      margin: 0,
      padding: 0,
    },
    h4: {
      fontFamily: ['"Mulish"', "sans-serif"].join(", "),
      fontSize: "1.25rem",
      fontWeight: 400,
      margin: 0,
      padding: 0,
    },
    h5: {
      fontFamily: ['"Mulish"', "sans-serif"].join(", "),
      fontSize: "1.125rem",
      fontWeight: 400,
      margin: 0,
      padding: 0,
    },
    h6: {
      fontFamily: ['"Mulish"', "sans-serif"].join(", "),
      fontSize: "1rem",
      fontWeight: 400,
      margin: 0,
      padding: 0,
    },
    fontFamily: ['"Mulish"', "sans-serif"].join(", "),
    body1: {
      fontFamily: ['"Mulish"', "sans-serif"].join(", "),
      fontSize: "16px",
      lineHeight: "24px",
      fontWeight: 500,
      margin: 0,
      padding: 0,
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    body2: {
      fontFamily: ['"Mulish"', "sans-serif"].join(", "),
      fontSize: "14px",
      lineHeight: "22px",
      fontWeight: 400,
      margin: 0,
      padding: 0,
      color: variables.text.primary,
    },
    secondaryFontFamily: ['"Source Code Pro"', "monospace"].join(", "),
    caption: {
      fontFamily: ['"Source Code Pro"', "monospace"].join(", "),
      fontSize: "0.85rem",
      margin: 0,
      padding: 0,
    },
    color: "#495B6D",
    bold: {
      fontWeight: 800,
    },
    semiBold: {
      fontWeight: 700,
    },
    breadCrumb: {
      fontFamily: ['"Mulish"', "sans-serif"].join(", "),
      fontSize: "14px",
      lineHeight: "22px",
      fontWeight: 400,
      margin: 0,
      padding: 0,
    },
  },
  background: {
    backgroundColor: `rgb(227, 242, 253)`,
  },
  borderBottom: {
    borderBottom: `1px solid ${variables.border.primary}`,
  },
  primaryColor: {
    color: variables.text.primary,
  },
  secondaryColor: {
    color: variables.text.secondary,
  },
  border: {
    border: `1px solid ${variables.border.primary}`,
  },
  borderBottom: {
    borderBottom: `1px solid ${variables.border.primary}`,
  },
  borderTop: {
    borderTop: `1px solid ${variables.border.primary}`,
  },
  borderRight: {
    borderRight: `1px solid ${variables.border.primary}`,
  },
  borderLeft: {
    borderLeft: `1px solid ${variables.border.primary}`,
  },
});
